'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function FeedbackDialog() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [Dialog, _AnalyticsData];
  this.analytics = new Analytics();

  this.url = '/member/account/feedback-dialog';
  this.close = true;
  this.backgroundClose = true;
  this.cancelDoesClose = true;
  this.userSubmittedFeedbackThisVisit = false;

  this.init = function () {
    this._super();
    this.$node = $(this.node);
    this._$dialogTrigger = $('.js--feedback-dialog-trigger');
    if (this._$dialogTrigger.length < 1) return;

    this._$dialogTrigger.on('click', this.show.bind(this, null));

    this.$node.find('.icon--close').attr('data-analytics-id', 'Money-Feedback-Close-null-Click');
    $('#' + this.id + '_overlay').attr('data-analytics-id', 'Money-Feedback-Close-null-Click');

    this._addComputedVariables();
  };

  this.initAllReady = function () {
    this._super();
  };

  this._onCreateOfferFeedback = function (data, response) {
    if (response !== 200) {
      $('#Notification').mogo().get();
      return false;
    }

    this.userSubmittedFeedbackThisVisit = true;

    this._$feedbackParent.removeClass('feedback-dialog__content--edit');
    this._$feedbackParent.addClass('feedback-dialog__content--submitted');
    this.resize();

    this.$node.find('.icon--close').attr('data-analytics-id', 'Money-Feedback-Finish-null-Click');
    $('#' + this.id + '_overlay').attr('data-analytics-id', 'Money-Feedback-Finish-null-Click');

    this.presenter.updateDOM();

    var $listOfInputs = $('.js--feedback-dialog-form-options input[type=radio]');
    var positionInList = null;
    for (var i = 0; i < $listOfInputs.length; i++) {
      if ($($listOfInputs[i]).attr('value') === data.feedback) {
        positionInList = i + 1;
      }
    }

    this.analytics.pushEvent('loan-offer-feedback-submitted', {
      FeedbackState: [positionInList, data.feedback]
    });
  };

  this.onUrlLoaded = function () {
    var _this = this;

    this._contentful = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, { verboseLevel: 1 }));

    this._contentful.getResource('ENTRY', { entry_id: 'HAM1XTspe6Y44QCe2EUKS' }, function (contentfulData) {
      if (_this._aborted) {
        return;
      }

      _this._$feedbackParent = _this.$node.find('.js--feedback-parent');
      _this._$feedbackCloseButton = _this.$node.find('.js--feedback-dialog-close-button');
      _this._$questionContainer = _this.$node.find('.js--feedback-dialog-form-options');
      _this._$feedbackFormContainer = _this.$node.find('.js--feedback-dialog-form-container');
      _this._$feedbackForm = _this.$node.find('.js--feedback-dialog-form');

      _this._$feedbackCloseButton.on('click', _this.hide.bind(_this));

      _this._questionSet = contentfulData.items[contentfulData.items.length - 1].relatedContentEntries.filter(function (entry) {
        return entry._contentType.sys.id != 'pageSectionMedia';
      })[0];
      _this._questionSetID = _this._questionSet._id;
      _this._questions = _this._questionSet.listItems;

      _this._$feedbackId = $('<input type="hidden" name="feedback_id" />').val(_this._questionSetID);
      _this._$booleanContainer = $('<div data-mogo-ui="BooleanGroup" data-bind="money.offers.feedback_question" name="feedback"></div>');
      _this._$questionContainer.append(_this._$feedbackId);
      _this._$questionContainer.append(_this._$booleanContainer);

      for (var i = 0; i < _this._questions.length; i++) {
        var question = _this._questions[i].content;
        _this._$booleanContainer.append('<div class="feedback-dialog__radio-option"><input data-mogo-ui="Radio" type="radio" name="feedback_option" value="' + question + '" placeholder="' + question + '" /></div>');
      }

      _this._$feedbackFormContainer.mogo().parse();
      _this._$feedbackCloseButton.mogo().parse();
      _this.presenter.scanDOM();

      _this._$submitButton = _this.$node.find('.js-feed-back-submit-button');
      _this._$submitButton.mogo().setDisabledState();

      _this.$node.on('change', '.js--feedback-dialog-form-options input[type=radio]', function () {
        var hasChecked = _this.$node.find('.js--feedback-dialog-form-options').has('input[type=radio]:checked').length;

        if (hasChecked) {
          _this._$submitButton.mogo().removeDisabledState();
        } else {
          _this._$submitButton.mogo().setDisabledState();
        }
      });

      // Add Callback to Form submit Action
      _this._createOfferFeedbackCallback = _this.presenter.addCallbackToAction('money.offers.create_offer_feedback', _this._onCreateOfferFeedback.bind(_this));

      _this.presenter.extendViewMap({
        'money.offers.feedback_question': {
          set: function set(value) {
            return value[0];
          },
          get: function get(value) {
            return value;
          }
        }
      });
    });
  };

  this.hide = function () {
    this._super();
    this.presenter.setModelProperty('money.offers.feedback_question', '');
    if (_typeof(this._$submitButton) === 'object') this._$submitButton.mogo().setDisabledState();
  };

  this._addComputedVariables = function () {
    var _this2 = this;

    this.presenter.addComputedVariable('userSubmittedFeedbackThisVisit', [], function () {
      return _this2.userSubmittedFeedbackThisVisit;
    });
  };

  this.destroy = function () {
    this._super();
    this._aborted = true;
    this.presenter.removeComputedVariable('userSubmittedFeedbackThisVisit');
  };
}